module.exports = __webpack_public_path__ + "media/images/summary_backpack-588cb92a.svg";